import React, { Component } from 'react'

export class Scheduleb extends Component {
    render() {
        return (
                    <div className="box">
                    <div className="box-body">
                        <div className="box-header">
                            <h3 className="box-title">Schedule-B</h3>
                        </div>
                        <div className="alert alert-danger" role="alert">
                            <p>Schedule - B Total Amount should match with the Accepted Contract Price</p>
                            <p>Users are requested to enter the Net Rate in Schedule - B (i.e. after adding/subtracting The Tender Rate based on Above/Below Tender)</p>
                        </div>
                        <div className="col-md-12">
                            <form action="partworksdetails/schbupload">
                                <div className="col-md-4">
                                <div className="form-group">
                                    <label>Excel for SCHEDULE-B</label> 
                                    <input type="file" name="excel_file" id="excel_file" />
                                </div>
                                </div>
                                <div className="col-md-4" style={{padding: '2.3%'}}>
                                <input type="submit" className="btn btn-primary" value="Upload" />
                                </div>
                            </form>
                            <div className="col-md-4">
                                <a href="public/sample_schb.xls">Click Here to download the sample work excel sheet</a> 
                            </div>
                        </div>
                        <div className="col-md-12">
                            <form action="partworksdetails/schedubitemsave">
                                <div className="col-md-3">
                                <div className="form-group">
                                    <label>Description</label> 
                                    <textarea name="description" className="form-control" />
                                </div>
                                </div>
                                <div className="col-md-2">
                                <div className="form-group">
                                    <label>Unit</label> 
                                    <input type="text" name="unit" className="form-control" />
                                </div>
                                </div>
                                <div className="col-md-3">
                                <div className="form-group">
                                    <label>Quantity</label> 
                                    <input type="text" name="quantity" className="form-control" />
                                </div>
                                </div>
                                <div className="col-md-3">
                                <div className="form-group">
                                    <label>Rate</label> 
                                    <input type="text" name="rate" className="form-control" />
                                </div>
                                </div>
                                <div className="col-md-1" style={{ padding: '2.3%'}}>
                                <input type="submit" className="btn btn-primary" value="Save" />
                        </div>
                        </form>	
                        <div className="col-md-12 table-responsive">
                            <table className="table table-bordered">
                                <thead>
                                <tr>
                                    <th>Sr.No.</th>
                                    <th>Description</th>
                                    <th>Unit</th>
                                    <th>Quantity</th>
                                    <th>Rate</th>
                                    <th>Amount</th>
                                    <th>Edit</th>
                                    <th>Delete</th>
                                </tr>
                                </thead>
                                <tr>
                                <td colspan="5" className="text-right">Total</td>
                                <td className="text-right"><strong></strong></td>
                                <td colspan="2"></td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <h3 className="box-title">Extra Item</h3>
                    <div className="col-md-12">
                        <form action="partworksdetails/schedubitemsave">
                            <div className="col-md-3">
                                <div className="form-group">
                                <label>Description</label> 
                                <textarea name="description" className="form-control" />
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                <label>Unit</label> 
                                <input type="text" name="unit" className="form-control" />
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                <label>Quantity</label> 
                                <input type="text" name="quantity" className="form-control" />
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                <label>Rate</label> 
                                <input type="text" name="rate" className="form-control" />
                                </div>
                            </div>
                            <div className="col-md-1" style={{padding: '2.3%'}} >
                            <input type="submit" className="btn btn-primary" value="Save" />
                    </div>
                    </form>	
                    <div className="col-md-12 table-responsive">
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                <th>Sr.No.</th>
                                <th>Description</th>
                                <th>Unit</th>
                                <th>Quantity</th>
                                <th>Rate</th>
                                <th>Amount</th>
                                <th>Edit</th>
                                <th>Delete</th>
                                </tr>
                            </thead>
                            <tr>
                                <td colspan="5" className="text-right">Total</td>
                                <td className="text-right"><strong></strong></td>
                                <td colspan="2"></td>
                            </tr>
                        </table>
                    </div>
                    </div>
                    </div>
                    </div>
        )
    }
}

export default Scheduleb
